export const downloadFile = (file: Blob, fileName: string): void => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(file);
  link.download = fileName;
  link.click();
};
